// import 'svgxuse'; // Uncomment to support svg icons on IE

import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/offcanvas";
import "bootstrap/js/dist/tab";
import ScrollSpy from "bootstrap/js/dist/scrollspy";
import Tooltip from "bootstrap/js/dist/tooltip";
import "./components/header";
import "./components/loadmore";
import "./components/partnersearch";
import "./components/smooth-scroll";
import "./components/eaplus";
import "./components/autocomplete";
import "./components/sliders";
import "./blocks/comparison";
import "./blocks/custom-cart";
import "./blocks/cost-calculator";
import "./blocks/see-my-price";
import "./blocks/ghp-post-purchase-offer";
import "./blocks/plan-addons";
import "./blocks/partner-search";
import "./blocks/help-me-choose";
import { bootstrap as initMediaAccordion } from "./blocks/media-accordion";
import "./pages/checkout";
import "./pages/checkout-draft";
import "./pages/ghp-checkout";

// BS Tooltip init
const tooltipTriggerList = document.querySelectorAll(
  '[data-bs-toggle="tooltip"]'
);
const tooltipList = [...tooltipTriggerList].map(
  (tooltipTriggerEl) => new Tooltip(tooltipTriggerEl)
);

// BS Scrollspy init
const scrollSpy = new ScrollSpy(document.body, {
  target: "#js-scrollspy",
  rootMargin: "0px 0px -75% 0px",
});

// Update WC scroll_to_notices
jQuery(function ($) {
  $.scroll_to_notices = function (scrollElement) {
    if (scrollElement.length) {
      $("html, body").animate({ scrollTop: 0 }, 1000);
    }
  };
});

initMediaAccordion();
